module.exports = __webpack_public_path__ + "static/media/tranzer_home.993e520b.png";